import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import UitkTableCellContext from './uitk-table-context.esm.js';
import styles from './uitk-tables.css';
import { UitkTableCellTag } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkTableHead = function (props) {
    var _a;
    var children = props.children, className = props.className, frozenRow = props.frozenRow, frozenRegionsStyle = props.frozenRegionsStyle, attributes = __rest(props, ["children", "className", "frozenRow", "frozenRegionsStyle"]);
    var baseClassName = 'uitk-table-head';
    var headClassNames = getClassNameList(baseClassName, className, (_a = {},
        _a["".concat(baseClassName, "-frozen")] = frozenRow === 'headerRow',
        _a["".concat(baseClassName, "-frozen-gradient")] = frozenRow === 'headerRow' &&
            frozenRegionsStyle !== 'columnGradient-rowBorder' &&
            frozenRegionsStyle !== 'columnGradient-rowNoBorder' &&
            frozenRegionsStyle !== 'onlyBorders',
        _a["".concat(baseClassName, "-frozen-border")] = frozenRow === 'headerRow' &&
            (frozenRegionsStyle === 'columnGradient-rowBorder' || frozenRegionsStyle === 'onlyBorders'),
        _a));
    return children ? (React.createElement(UitkTableCellContext.Provider, { value: { tag: UitkTableCellTag.header } },
        React.createElement("thead", __assign({ className: headClassNames }, attributes), children))) : null;
};
UitkTableHead.displayName = 'UitkTableHead';

export { UitkTableHead };
